<template lang="pug">
  div( class="full-width" )
    v-layout( row wrap )
      v-flex( xs12 class="px-4 mt-3" )
        v-form(
          v-model="valid"
          class="credit-form"
          ref="loanApplication"
        )
          template(v-for="field in formTwo")
            component(
              :is="field.type || 'v-text-field'"
              :key="field.v_model_name"
              :id="field.id"
              :label="fortivaGaiLabel(field)"
              :placeholder="field.placeholder"
              v-model="customerDataCopy[field.v_model_name]"
              :rules="field.rules"
              :required="fortivaGaiRequired(field)"
              :mask="field.mask"
              v-money="field.money || null"
              @focus="showDisclaimer(field.disclaimerVariable)"
              @blur="hideDisclaimer(field.disclaimerVariable)"
              validate-on-blur
              @keyup.enter="submitForm"
              :hint="field.hint"
              class="text-xs-left"
              v-bind="field.attrs"
            )
            disclaimer-tooltip(
              v-if="field.hasDisclaimer && greenskyPreQual"
              :text="tooltipText(field)"
              v-show="showVars[field.disclaimerVariable]"
              :id="field.disclaimerId"
            )
            disclaimer-tooltip(
              v-else-if="field.hasDisclaimer"
              :text="tooltipText(field)"
              v-show="showVars[field.disclaimerVariable]"
              :id="field.disclaimerId"
            )

          v-layout( v-if="hasMobileOptIn" class="text-xs-left mb-3" )
            v-flex(xs1)
              v-checkbox(
                v-model="customerDataCopy['applicantMobileOptIn']"
              )
            v-flex( xs11 class="caption" v-html="greenskyPreQualNotice")
          template(
            v-if="showMaritalStatus"
          )
            v-select(
              v-model="customerDataCopy['maritalStatus']"
              label="Marital Status"
              id="test-marital-status"
              :items="maritalStatuses"
              :rules="maritalStatusRules"
              required
            )
            template(
              v-if="customerDataCopy.maritalStatus === 'Married'"
            )
              v-text-field(
                v-for="field in wisconsinSpouseData"
                :key="field.v_model_name"
                :label="field.label"
                v-model="customerDataCopy[field.v_model_name]"
                :rules="field.rules"
                :required="field.required"
                :id="field.id"
                validate-on-blur
                @keyup.enter="submitForm"
              )

      v-flex(xs10)
        ConsentCheckbox(
          v-if="showCoapplicantBox"
          :accepted="hasCoapplicant"
          :text="coapplicantText"
          @boxChecked="x => $emit('checkedCoapplicant', x)"
          class="ml-4"
        )

      AppNextButton(
        class="mt-2 next-btn"
        :buttonFunction="submitForm"
        id="form-submit"
      )  Next
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import ConsentCheckbox from 'Components/ConsentCheckbox.vue'
  import DisclaimerTooltip from 'Components/DisclaimerTooltip.vue'
  import { FormPageMixin } from 'Mixins/FormPageMixin.js'
  import { formDataPageTwo, wisconsinSpouseData } from 'Helpers/CreditApplicationFormHelper.js'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'CreditFormPageTwo',
    components: {
      AppNextButton,
      ConsentCheckbox,
      DisclaimerTooltip,
    },
    mixins: [
      FormPageMixin
    ],
    data () {
      return {
        coapplicantText: 'Please check this box if you wish to apply with a Co-Applicant',
        formDataPageTwo,
        formTwo: [],
        wisconsinSpouseData,
        showVars: {
          showIncome: false,
          showPhone: false
        },
        maritalStatuses: [
          'Single',
          'Married'
        ],
        maritalStatusRules: [
          (v) => !!v || 'Marital Status is required'
        ],
      }
    },
    computed: {
      ...mapState({
        hasPreQual: state => state.preQualification.hasPreQual,
        phoneDisclosure: state => state.greensky.greenskyLegalContent.phoneDisclosure
      }),
      greenskyPreQual() {
        return this.lenderName === 'greensky' && this.hasPreQual
      },
      greenskyPreQualNotice() {
        return this.greenskyPreQual 
        ? `<h3>I agree and understand the following notice:</h3> <p class="mt-1">You are providing ‘written instructions’ to the GreenSky® Program under the Fair Credit Reporting Act authorizing the GreenSky® Program to obtain information from your personal credit profile or other information from Experian. You authorize the GreenSky® Program to obtain such information solely to conduct a pre-qualification for credit. </p>
        <p> You have read, understand, and accept GreenSky’s <a href="https://www.greensky.com/terms/website_terms_of_use.pdf" target="_blank"> Terms of Use</a>, and GreenSky’s <a href="https://www.greensky.com/privacy-policy" target="_blank"> Privacy Notice</a>, and GreenSky’s <a href="https://www.greenskycredit.com/information" target="_blank"> Consent to Electronic Records and Communication</a>. </p>
        <p> When you check your rate and review loan offers, a soft inquiry will be performed on your credit report, which won’t impact your credit score. Soft inquiries can only be seen by you. When you accept a loan offer and submit it for review, a hard inquiry will be performed, which may impact your credit score and can be viewed by third parties. `
        : `By checking this box, ${this.phoneDisclosure}`
      },
    },
    props: {
      hasCoapplicant: {
        type: Boolean,
        default: false
      },
      showCoapplicantBox: {
        type: Boolean,
        default: false
      },
      showMaritalStatus: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      ...mapActions(['getGreenskyLegalContent']),
      hideDisclaimer (attribute) {
        if (attribute) {
          this.showVars[attribute] = false
        }
      },
      fortivaGaiLabel (field) {
        if (this.lenderName === 'fortiva' && field.fortivaLabel) {
          return field.fortivaLabel
        } else {
          return field.label
        }
      },
      fortivaGaiRequired (field) {
        if (this.lenderName === 'fortiva' &&
          field.v_model_name === 'grossAnnualIncome') {
          return false
        } else {
          return field.required
        }
      },
      showDisclaimer (attribute) {
        if (attribute) {
          this.showVars[attribute] = true
        }
      }
    },
    async mounted(){
      if (this.lenderName === 'greensky'){
        this.formTwo = await this.getGreenskyLegalContent(formDataPageTwo)
      } else {
        this.formTwo = formDataPageTwo()
      }
    }
  }
</script>
